import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class DataBatch {
	constructor() {
        ScrollTrigger.batch("[data-batch]", {
            onEnter: batch => gsap.to(batch, {
               y: 0,
               autoAlpha: 1,
               stagger: 0.1
            }),
            start: "top 90%"
        });
	}
}
